import {
  priceCellRenderer,
  packagePriceCellRenderer,
  agTableQuantityCellRenderer,
  totalCellRenderer,
  isNewRenderer,
  departmentCellRenderer,
  availabilityFilterFormatter,
  availabilityValueGetter,
  hasPromotionRenderer,
} from '../cellRenderers.jsx';

const numberComparator = (a, b) => a - b;
const packagePriceComparator = (valueA, valueB, nodeA, nodeB) =>
  nodeA.data.applicable_price * nodeA.data.pcb - nodeB.data.applicable_price * nodeB.data.pcb;

const columnDefs = [
  {
    colId: 'department',
    headerName: 'Département',
    field: 'type',
    sortable: true,
    filter: true,
    floatingFilter: true,
    hide: true,
    cellRenderer: departmentCellRenderer,
    suppressColumnsToolPanel: true,
    filterParams: {
      cellRenderer: departmentCellRenderer,
    },
  },
  {
    colId: 'zone',
    headerName: 'Secteur',
    field: 'zone_name',
    sortable: true,
    filter: true,
    floatingFilter: true,
    hide: true,
    suppressColumnsToolPanel: true,
  },
  {
    colId: 'aisle',
    headerName: 'Rayon',
    field: 'aisle_name',
    sortable: true,
    filter: true,
    floatingFilter: true,
    hide: true,
    suppressColumnsToolPanel: true,
  },
  {
    colId: 'category',
    headerName: 'Famille',
    field: 'category_name',
    sortable: true,
    filter: true,
    floatingFilter: true,
    hide: true,
    suppressColumnsToolPanel: true,
  },
  {
    colId: 'sub_category',
    headerName: 'Sous-Famille',
    field: 'subcategory_name',
    sortable: true,
    filter: true,
    floatingFilter: true,
    hide: true,
    suppressColumnsToolPanel: true,
  },
  {
    colId: 'top_sales_position',
    headerName: 'Postion top vente',
    field: 'topPosition',
    sortable: true,
    filter: true,
    hide: true,
    suppressColumnsToolPanel: true,
  },
  {
    headerName: 'Nouveauté',
    field: 'is_new',
    sortable: true,
    filter: true,
    floatingFilter: true,
    cellRenderer: isNewRenderer,
    filterParams: {
      cellRenderer: isNewRenderer,
    },
    suppressColumnsToolPanel: true,
    hide: true,
  },
  {
    headerName: '',
    field: 'ean13',
    suppressColumnsToolPanel: true,
    sortable: true,
    cellRenderer: 'imageCellRenderer',
    cellClass: 'image-cell',
    width: 50,
    suppressSizeToFit: true,
  },
  {
    headerName: 'Référence',
    field: 'reference',
    sortable: true,
    suppressColumnsToolPanel: true,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    suppressFiltersToolPanel: true,
    width: 138,
    filterParams: {
      suppressAndOrCondition: true,
      filterOptions: ['contains'],
    },
    suppressSizeToFit: true,
  },
  {
    headerName: 'EAN',
    colId: 'ean13',
    field: 'ean13',
    sortable: true,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    suppressFiltersToolPanel: true,
    width: 161,
    filterParams: {
      suppressAndOrCondition: true,
      filterOptions: ['contains'],
    },
    suppressColumnsToolPanel: true,
    suppressSizeToFit: true,
  },
  {
    headerName: 'Libellé',
    field: 'name',
    sortable: true,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    minWidth: 170,
    filterParams: {
      suppressAndOrCondition: true,
      filterOptions: ['contains'],
    },
    suppressFiltersToolPanel: true,
    suppressColumnsToolPanel: true,
  },
  {
    headerName: 'Marque',
    field: 'manufacturer.name',
    sortable: true,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    filterParams: {
      suppressAndOrCondition: true,
      filterOptions: ['contains'],
    },
    hide: true,
  },
  {
    headerName: 'PCB',
    field: 'pcb',
    comparator: numberComparator,
    sortable: true,
    filter: true,
    floatingFilter: true,
    suppressFiltersToolPanel: true,
    cellStyle: { 'text-align': 'center' },
    width: 100,
    suppressSizeToFit: true,
    suppressColumnsToolPanel: true,
  },
  {
    headerName: 'Prix unitaire',
    field: 'applicable_price',
    sortable: true,
    filter: 'agNumberColumnFilter',
    cellRenderer: 'priceCellRenderer',
    floatingFilter: true,
    suppressFiltersToolPanel: true,
    cellStyle: { 'text-align': 'center' },
    width: 140,
    filterParams: {
      suppressAndOrCondition: true,
      filterOptions: ['greaterThan', 'lessThan', 'equals'],
    },
    suppressColumnsToolPanel: true,
    suppressSizeToFit: true,
    comparator: numberComparator,
  },
  {
    headerName: 'Prix colis',
    field: 'applicable_price',
    sortable: true,
    filter: 'agNumberColumnFilter',
    cellRenderer: 'packagePriceCellRenderer',
    floatingFilter: true,
    suppressFiltersToolPanel: true,
    cellStyle: { 'text-align': 'center' },
    width: 150,
    filterParams: {
      suppressAndOrCondition: true,
      filterOptions: ['greaterThan', 'lessThan', 'equals'],
    },
    suppressColumnsToolPanel: true,
    suppressSizeToFit: true,
    comparator: packagePriceComparator,
  },
  {
    headerName: 'Promotion',
    field: 'promotion_id',
    sortable: true,
    filter: true,
    hide: true,
    valueGetter: hasPromotionRenderer,
    colId: 'promotion',
    lockVisible: true,
    suppressColumnsToolPanel: true,
  },
  {
    headerName: 'Sélection',
    field: 'group_item',
    sortable: true,
    filter: 'AssortmentFilter',
    hide: true,
    lockVisible: true,
    suppressColumnsToolPanel: true,
  },
  {
    headerName: 'Quantités',
    colId: 'quantity',
    field: 'product',
    cellRendererFramework: agTableQuantityCellRenderer,
    pinned: 'right',
    cellStyle: { 'background-color': '#FBFBFD' },
    suppressFiltersToolPanel: true,
    suppressColumnsToolPanel: true,
    suppressSizeToFit: true,
    width: 150,
  },
  {
    headerName: 'Total',
    colId: 'total',
    field: 'product',
    cellRendererFramework: totalCellRenderer,
    pinned: 'right',
    cellStyle: {
      'background-color': '#FBFBFD',
      'text-align': 'center',
    },
    suppressFiltersToolPanel: true,
    suppressColumnsToolPanel: true,
    suppressSizeToFit: true,
    width: 138,
  },
  {
    headerName: 'Disponibilité',
    colId: 'availability',
    field: 'stock',
    sortable: true,
    filter: 'agSetColumnFilter',
    floatingFilter: true,
    valueGetter: availabilityValueGetter,
    keyCreator: availabilityFilterFormatter,
    cellRenderer: 'availabilityCellRenderer',
    pinned: 'right',
    cellStyle: { 'background-color': '#FBFBFD' },
    suppressSizeToFit: true,
    width: 138,
    suppressColumnsToolPanel: true,
  },
];

export default columnDefs;
